'use client';

import clsx from 'clsx';

import Chevron from '@/shared/assets/chevron.svg?svg';
import Email from '@/shared/assets/email.svg?svg';
import Hand from '@/shared/assets/hand.svg?svg';
import Twitter from '@/shared/assets/twitter.svg?svg';
import { Text } from '@/shared/ui';
import {
  Collapsable,
  CollapsableContent,
  CollapsableTrigger,
} from '@/shared/ui/Collapsable';
import { TelegramModal } from '../TelegramModal';
import styles from './Apps.module.css';

const ActiveTriggerContent = () => {
  return (
    <div className={clsx(styles.triggerContent, styles.triggerContent_active)}>
      <Text
        fontSize={11}
        fontWeight={500}
        lineHeight={12}
        color="text-secondary"
      >
        Всегда под рукой
      </Text>
    </div>
  );
};

const InactiveTriggerContent = () => (
  <div className={clsx(styles.triggerContent, styles.triggerContent_inactive)}>
    <Hand width={20} height={20} />
    <Text
      color="text-primary"
      fontSize={13}
      fontWeight={400}
      lineHeight={20}
      variant="secondary"
    >
      Всегда под рукой
    </Text>
  </div>
);

const Content = () => (
  <>
    <TelegramModal />
    <a
      className={styles.item}
      href="https://x.com/crimerussia_com"
      target="_top"
    >
      <Twitter width={24} height={24} />
      <Text
        color="text-secondary"
        fontSize={12}
        fontWeight={700}
        lineHeight={20}
      >
        X (Twitter)
      </Text>
    </a>
    <a className={styles.item} href="mailto:i@crimerussia.com" target="_top">
      <Email />
      <Text
        color="text-secondary"
        fontSize={12}
        fontWeight={700}
        lineHeight={20}
      >
        i@crimerussia.com
      </Text>
    </a>
  </>
);

export const Apps = ({ className }: { className?: string }) => {
  return (
    <>
      <Collapsable className={clsx(styles.apps, className)} defaultOpen>
        <CollapsableTrigger className={styles.trigger}>
          <ActiveTriggerContent /> <InactiveTriggerContent />
          <Chevron className={styles.chevron} />
        </CollapsableTrigger>
        <CollapsableContent>
          {/* <Item>
            <AppIcon />
            <Text
              color="text-primary"
              fontSize={12}
              fontWeight={700}
              lineHeight={20}
            >
              Скачать приложение
            </Text>
          </Item> */}
          <Content />
        </CollapsableContent>
      </Collapsable>

      <div className={styles.mobile}>
        <Text
          className={styles.mobile__title}
          fontSize={11}
          fontWeight={500}
          lineHeight={12}
          color="text-secondary"
        >
          Всегда под рукой
        </Text>
        <Content />
      </div>
    </>
  );
};
